import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { insertAdditionalDiscountServices } from 'modules/accommodations/features/reservations/api';

export const useMutationInsertAdditionalDiscountServices = () => {
  const queryClient = useQueryClient();
  const { errorToast } = useCustomToast();

  const { mutateAsync, isLoading, isError, data } = useMutation(insertAdditionalDiscountServices, {
    onSettled: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_NEW_ADDITIONAL_DISCOUNT_SERVICES);
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RESERVATION_INSERT_NEW_ADDITIONAL_DISCOUNT_SERVICES);
    },
    onError: (error: any) => {
      const errorMessage = error?.response?.data?.ErrorDescription;
      errorToast(errorMessage);
    },
  });

  return {
    insertAdditionalDiscountServicesMutate: mutateAsync,
    additionalDiscountServicesLoading: isLoading,
    additionalDiscountServicesError: isError,
    additionalDiscountServicesData: data,
  };
};
